export default {
  mounted(el, binding) {
    if (!binding.value) return;

    const prevent = e => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // 🚨 CAPTURE PHASE
    const events = ['paste', 'keydown', 'drop', 'cut', 'beforeinput'];

    events.forEach(evt => {
      el.addEventListener(evt, prevent, true);
    });
  },
  beforeUnmount(el) {
    const events = ['paste', 'keydown', 'drop', 'cut', 'beforeinput'];
    events.forEach(evt => {
      el.removeEventListener(evt, () => {}, true);
    });
  }
};